// extracted by mini-css-extract-plugin
module.exports = {"root":"HospitalDashboard_root__1u7_r","pieCard":"HospitalDashboard_pieCard__2kcTx","cardTitle":"HospitalDashboard_cardTitle__1bk0b"};